import {CodeBlock} from "@/components/codeBlock/CodeBlock.tsx";
import {MultiSnippet} from "@/lib/types/website.ts";

interface MultiSnippetBlockProps {
  uuid: string;
  title: string;
  snippet: MultiSnippet;
  onModal?: boolean;
}

export const MultiSnippetBlock = ({uuid, title, snippet, onModal}: MultiSnippetBlockProps) => (
  <>
    {!onModal && <div className="pulseTextH3Bold mb-4 mt-4 pt-2">{title}</div>}
    <div className="pulseTextBodySmallBold mb-1">Use the following URL to send data to your Check</div>
    <CodeBlock code={snippet.url.replace("##UUID##", uuid)} className="mb-4" onModal={onModal} />
    <div className="pulseTextBodySmallBold mb-1">Example using cURL</div>
    <CodeBlock code={snippet.snippet1.replace("##UUID##", uuid)} className="mb-4" onModal={onModal} />
    <div className="pulseTextBodySmallBold mb-1">Example using cURL with timeseries metrics</div>
    <CodeBlock code={snippet.snippet2.replace("##UUID##", uuid)} onModal={onModal} />
    {onModal && (
      <div className="pulseTextBodySmall mt-4">
        Note: Your {title.split(" ").slice(0, 2).join(" ")} can be permanently found in the{" "}
        <span className="pulseTextBodySmallBold">General</span> tab.
      </div>
    )}
  </>
);
